import { useEffect, useRef, useState } from "react";
import { compareAsc } from "date-fns";
import clockImg from "../../picture/clock.png";
import starImg from "../../picture/zvezda.png";
import "./customTimer.css";

const CustomTimer = ({
  selectedDate,
  currentNotification,
  setCurrentNotification,
  isFromSliderRef,
  isEditing,
}) => {
  const startHoursRef = useRef();
  const startMinutesRef = useRef();
  const endHoursRef = useRef();
  const endMinutesRef = useRef();

  const resetInput = (ref) => {
    if (ref.current) {
      setTimeout(() => {
        ref.current.value = "";
        ref.current.classList.remove("element-red");
      }, 500);
    }
  };

  const handleCheckInputStartHours = (e) => {
    if (isFromSliderRef) isFromSliderRef.current = false;

    let currentValue = e.currentTarget.value.toString();
    let currentHours, currentMinutes;
    currentHours = new Date().getHours();
    currentMinutes = new Date().getMinutes();

    if (currentValue.length > 2) {
      currentValue = currentValue.slice(0, 2);
      startHoursRef.current.value = currentValue;
    }

    // ako je ukucao prvu cifru i veca je od 2
    if (currentValue.length === 1 && parseInt(currentValue) > 2) {
      startHoursRef.current.classList.add("element-red");
      resetInput(startHoursRef);
    }
    // ako ukuca neke sate vece od 23
    if (
      currentValue.length === 2 &&
      parseInt(currentValue.charAt(0)) === 2 &&
      parseInt(currentValue.charAt(1)) > 3
    ) {
      startHoursRef.current.classList.add("element-red");
      resetInput(startHoursRef);
    }
    // za isti dan ukoliko su trenutni sati jednocifreni i ukucano je manje od trenutnog sata
    const isToday =
      compareAsc(
        new Date(selectedDate.setHours(0, 0, 0, 0)),
        new Date(new Date().setHours(0, 0, 0, 0))
      ) === 0;
    if (
      isToday &&
      currentValue.length === 1 &&
      currentHours.toString().length === 1 &&
      parseInt(currentValue) < currentHours
    ) {
      startHoursRef.current.classList.add("element-red");
      resetInput(startHoursRef);
    }
    if (
      isToday &&
      currentValue.length === 2 &&
      currentHours.toString().length === 2 &&
      parseInt(currentValue) < currentHours
    ) {
      startHoursRef.current.classList.add("element-red");
      resetInput(startHoursRef);
    }

    if (
      startMinutesRef.current.value !== "" &&
      startHoursRef.current.value !== ""
    ) {
      endHoursRef.current.disabled = true;
      endMinutesRef.current.disabled = true;
      endHoursRef.current.value = "";
      endMinutesRef.current.value = "";
      startMinutesRef.current.value = "";
    }

    /*if (currentValue.length === 1) {
      if (
        currentHours.toString().length === 1 &&
        parseInt(currentValue) < currentHours
      ) {
        startHoursRef.current.classList.add("element-red");
        setTimeout(() => {
          startHoursRef.current.value = "";
          startHoursRef.current.classList.remove("element-red");
        }, 500);
      } else if (parseInt(currentValue) === 0) startHoursRef.current.value = "";
      else startHoursRef.current.value = `0${currentValue}`;
    } else {
      if (currentValue.length > 2)
        e.currentTarget.value = currentValue.slice(1, 3);
      currentValue = currentValue.slice(1, 3);

      if (currentValue > 23) {
        startHoursRef.current.classList.add("element-red");
        setTimeout(() => {
          startHoursRef.current.value = "";
          startHoursRef.current.classList.remove("element-red");
        }, 500);
      }
      
      if (
        compareAsc(
          new Date(selectedDate.setHours(0, 0, 0, 0)),
          new Date(new Date().setHours(0, 0, 0, 0))
        ) === 0
      ) {
        if (
          parseInt(startHoursRef.current.value.toString().charAt(0)) <
            parseInt(currentHours.toString().charAt(0)) ||
          (parseInt(startHoursRef.current.value.toString().charAt(0)) ===
            parseInt(currentHours.toString().charAt(0)) &&
            parseInt(startHoursRef.current.value.toString().charAt(1)) <
              parseInt(currentHours.toString().charAt(1)))
        ) {
          startHoursRef.current.classList.add("element-red");
          setTimeout(() => {
            startHoursRef.current.value = "";
            startHoursRef.current.classList.remove("element-red");
          }, 500);
        }

      /*
      if (
        parseInt(e.currentTarget.value.toString().charAt(0)) <
          parseInt(corectMinutes.toString().charAt(0)) &&
        startHoursRef.current.value <= currentHours
      ) {
        if (startMinutesRef.current.value !== "") {
          startMinutesRef.current.classList.add("element-red");
          setTimeout(() => {
            startMinutesRef.current.value = "";
            startMinutesRef.current.classList.remove("element-red");
          }, 500);
        }
      }

      if (
        e.currentTarget !== startHoursRef.current &&
        startHoursRef.current.value <= currentHours
      ) {
        //startHoursRef.current.value = currentHours;
        startMinutesRef.current.classList.add("element-red");
        setTimeout(() => {
          startMinutesRef.current.value = "";
          startMinutesRef.current.classList.remove("element-red");
        }, 500);
      }
    }*/
  };
  //}

  const handleCheckInputStartMinutes = (e) => {
    if (startHoursRef.current.value === "") {
      startMinutesRef.current.value = "";
      return;
    }

    if (isFromSliderRef) isFromSliderRef.current = false;

    let currentValue = e.currentTarget.value.toString();

    if (currentValue.length > 2) {
      currentValue = currentValue.slice(0, 2);
      e.currentTarget.value = currentValue;
    }

    if (currentValue.length === 1 && parseInt(currentValue) > 5) {
      startMinutesRef.current.classList.add("element-red");
      resetInput(startMinutesRef);
    }

    let currentHours, currentMinutes;
    currentHours = new Date().getHours();
    currentMinutes = new Date().getMinutes();
    /*if (currentMinutes.toString().length === 1)
      currentMinutes = `0${currentMinutes}`;*/

    const isToday =
      compareAsc(
        new Date(selectedDate.setHours(0, 0, 0, 0)),
        new Date(new Date().setHours(0, 0, 0, 0))
      ) === 0;
    if (
      isToday &&
      currentValue.length === 1 &&
      currentMinutes.toString().length === 1 &&
      parseInt(startHoursRef.current.value) === parseInt(currentHours) &&
      parseInt(currentValue) < currentMinutes
    ) {
      startMinutesRef.current.classList.add("element-red");
      resetInput(startMinutesRef);
    }
    if (
      isToday &&
      currentValue.length === 2 &&
      currentMinutes.toString().length === 2 &&
      parseInt(startHoursRef.current.value) === parseInt(currentHours) &&
      parseInt(currentValue) < currentMinutes
    ) {
      startMinutesRef.current.classList.add("element-red");
      resetInput(startMinutesRef);
    }
    /*if (
      compareAsc(
        new Date(selectedDate.setHours(0, 0, 0, 0)),
        new Date(new Date().setHours(0, 0, 0, 0))
      ) === 0
    ) {
      if (
        parseInt(startHoursRef.current.value.toString().charAt(0)) <
          parseInt(currentHours.toString().charAt(0)) ||
        (parseInt(startHoursRef.current.value.toString().charAt(0)) ===
          parseInt(currentHours.toString().charAt(0)) &&
          parseInt(startHoursRef.current.value.toString().charAt(1)) <
            parseInt(currentHours.toString().charAt(1)))
      ) {
        startHoursRef.current.classList.add("element-red");
        setTimeout(() => {
          startHoursRef.current.value = "";
          startHoursRef.current.classList.remove("element-red");
        }, 500);

        //.currentTarget.value = currentHours;
      }

      if (
        parseInt(e.currentTarget.value.toString().charAt(0)) <
          parseInt(currentMinutes.toString().charAt(0)) &&
        startHoursRef.current.value <= currentHours
      ) {
        if (startMinutesRef.current.value !== "") {
          startMinutesRef.current.classList.add("element-red");
          setTimeout(() => {
            startMinutesRef.current.value = "";
            startMinutesRef.current.classList.remove("element-red");
          }, 500);
        }
      }

      if (
        e.currentTarget !== startHoursRef.current &&
        startHoursRef.current.value <= currentHours
      ) {
        startMinutesRef.current.classList.add("element-red");
        setTimeout(() => {
          startMinutesRef.current.value = "";
          startMinutesRef.current.classList.remove("element-red");
        }, 500);
      }
    }
*/
    handleDisableTime();
  };

  const handleDisableTime = () => {
    if (
      startMinutesRef.current.value.toString() !== "" &&
      startHoursRef.current.value.toString() !== ""
    ) {
      endHoursRef.current.disabled = false;
      endMinutesRef.current.disabled = false;
    } else {
      endHoursRef.current.disabled = true;
      endMinutesRef.current.disabled = true;
      endHoursRef.current.value = "";
      endMinutesRef.current.value = "";
    }
  };

  const handleOnBlurHours = () => {
    let currentHours = new Date().getHours();
    let currentValue = startHoursRef.current.value;
    const isToday =
      compareAsc(
        new Date(selectedDate.setHours(0, 0, 0, 0)),
        new Date(new Date().setHours(0, 0, 0, 0))
      ) === 0;
    if (isToday && currentValue < currentHours) {
      startHoursRef.current.classList.add("element-red");
      resetInput(startHoursRef);
    }
    if (currentValue.length === 1) {
      startHoursRef.current.value = `0${currentValue}`;
    }
  };

  const handleOnBlurMinutes = () => {
    let currentHours, currentMinutes;
    let currentValue = startMinutesRef.current.value;
    currentHours = new Date().getHours();
    currentMinutes = new Date().getMinutes();
    const isToday =
      compareAsc(
        new Date(selectedDate.setHours(0, 0, 0, 0)),
        new Date(new Date().setHours(0, 0, 0, 0))
      ) === 0;
    if (
      isToday &&
      parseInt(startHoursRef.current.value) === currentHours &&
      currentValue < currentMinutes
    ) {
      startMinutesRef.current.classList.add("element-red");
      endHoursRef.current.disabled = true;
      endMinutesRef.current.disabled = true;
      resetInput(startMinutesRef);
    }
    if (currentValue.length === 1) {
      startMinutesRef.current.value = `0${currentValue}`;
    }
  };

  const handleEndTimeOnBlurMinutes = () => {
    let currentValue = endMinutesRef.current.value;
    if (currentValue.length === 1) {
      endMinutesRef.current.value = `0${currentValue}`;
    }
    if (
      startHoursRef.current.value === endHoursRef.current.value &&
      parseInt(currentValue) < parseInt(startMinutesRef.current.value)
    ) {
      endMinutesRef.current.classList.add("element-red");
      resetInput(endMinutesRef);
    }
  };

  const handleEndTimeOnBlurHours = () => {
    let currentValue = endHoursRef.current.value;
    if (currentValue.length === 1) {
      endHoursRef.current.value = `0${currentValue}`;
    }

    if (parseInt(currentValue) < parseInt(startHoursRef.current.value)) {
      endHoursRef.current.classList.add("element-red");
      resetInput(endHoursRef);
    }
  };

  const handleCheckEndInputHours = () => {
    let currentValue = endHoursRef.current.value.toString();

    if (currentValue.length > 2) {
      currentValue = currentValue.slice(0, 2);
      endHoursRef.current.value = currentValue;
    }
    // ako je ukucao prvu cifru i veca je od 2
    if (currentValue.length === 1 && parseInt(currentValue) > 2) {
      endHoursRef.current.classList.add("element-red");
      resetInput(endHoursRef);
    }
    // ako ukuca neke sate vece od 23
    if (
      currentValue.length === 2 &&
      parseInt(currentValue.charAt(0)) === 2 &&
      parseInt(currentValue.charAt(1)) > 3
    ) {
      endHoursRef.current.classList.add("element-red");
      resetInput(endHoursRef);
    }
    let startHours = startHoursRef.current.value;
    if (
      currentValue.length === 1 &&
      startHours.length === 1 &&
      parseInt(currentValue) < parseInt(startHours)
    ) {
      endHoursRef.current.classList.add("element-red");
      resetInput(endHoursRef);
    }
    if (
      currentValue.length === 1 &&
      startHours.length === 2 &&
      parseInt(currentValue) < parseInt(startHours.charAt(0))
    ) {
      endHoursRef.current.classList.add("element-red");
      resetInput(endHoursRef);
    }
    if (
      currentValue.length === 2 &&
      startHours.toString().length === 2 &&
      parseInt(currentValue) < parseInt(startHours)
    ) {
      endHoursRef.current.classList.add("element-red");
      resetInput(endHoursRef);
    }
  };

  const handleCheckEndInputMinutes = () => {
    let currentValue = endMinutesRef.current.value.toString();

    if (currentValue.length > 2) {
      currentValue = currentValue.slice(0, 2);
      endMinutesRef.current.value = currentValue;
    }

    if (currentValue.length === 1 && parseInt(currentValue) > 5) {
      endMinutesRef.current.classList.add("element-red");
      resetInput(endMinutesRef);
    }
    let startMinutes = startMinutesRef.current.value;
    let startHours = startHoursRef.current.value;
    let endHours = endHoursRef.current.value;
    if (
      currentValue.length === 1 &&
      startMinutes.toString().length === 1 &&
      parseInt(startHours) === parseInt(endHours) &&
      parseInt(currentValue) <= parseInt(startMinutes)
    ) {
      endMinutesRef.current.classList.add("element-red");
      resetInput(endMinutesRef);
    }
    if (
      currentValue.length === 1 &&
      startMinutes.toString().length === 2 &&
      parseInt(startHours) === parseInt(endHours) &&
      parseInt(currentValue) < parseInt(startMinutes.charAt(0))
    ) {
      endMinutesRef.current.classList.add("element-red");
      resetInput(endMinutesRef);
    }
    if (
      currentValue.length === 2 &&
      startMinutes.toString().length === 2 &&
      parseInt(startHours) === parseInt(endHours) &&
      parseInt(currentValue) <= parseInt(startMinutes)
    ) {
      endMinutesRef.current.classList.add("element-red");
      resetInput(endMinutesRef);
    }
    /*if (
      compareAsc(
        new Date(selectedDate.setHours(0, 0, 0, 0)),
        new Date(new Date().setHours(0, 0, 0, 0))
      ) === 0
    ) {
      if (
        parseInt(startHoursRef.current.value.toString().charAt(0)) <
          parseInt(currentHours.toString().charAt(0)) ||
        (parseInt(startHoursRef.current.value.toString().charAt(0)) ===
          parseInt(currentHours.toString().charAt(0)) &&
          parseInt(startHoursRef.current.value.toString().charAt(1)) <
            parseInt(currentHours.toString().charAt(1)))
      ) {
        startHoursRef.current.classList.add("element-red");
        setTimeout(() => {
          startHoursRef.current.value = "";
          startHoursRef.current.classList.remove("element-red");
        }, 500);

        //.currentTarget.value = currentHours;
      }

      if (
        parseInt(e.currentTarget.value.toString().charAt(0)) <
          parseInt(currentMinutes.toString().charAt(0)) &&
        startHoursRef.current.value <= currentHours
      ) {
        if (startMinutesRef.current.value !== "") {
          startMinutesRef.current.classList.add("element-red");
          setTimeout(() => {
            startMinutesRef.current.value = "";
            startMinutesRef.current.classList.remove("element-red");
          }, 500);
        }
      }

      if (
        e.currentTarget !== startHoursRef.current &&
        startHoursRef.current.value <= currentHours
      ) {
        startMinutesRef.current.classList.add("element-red");
        setTimeout(() => {
          startMinutesRef.current.value = "";
          startMinutesRef.current.classList.remove("element-red");
        }, 500);
      }
    }
*/
    handleDisableTime();
  };

  useEffect(() => {
    if (
      isEditing ? !currentNotification.isFromSlider : !isFromSliderRef.current
    ) {
      let startTime = currentNotification.startTime.split(":");
      let endTime = currentNotification.endTime.split(":");

      if (endTime.length === 2) {
        endHoursRef.current.disabled = false;
        endMinutesRef.current.disabled = false;
      }

      startHoursRef.current.value = startTime[0];
      startMinutesRef.current.value = startTime[1];
      endHoursRef.current.value = endTime[0];
      endMinutesRef.current.value = endTime[1];
    }
  }, []);

  return (
    <div className="slider-timer">
      <div className="slider-timer-left">
        <img className="slider-timer-left-clock" src={clockImg} alt="" />
        <input
          type="number"
          onChange={handleCheckInputStartHours}
          onBlur={handleOnBlurHours}
          className="slider-timer-hours"
          ref={startHoursRef}
        />
        <span>:</span>
        <input
          type="number"
          onChange={handleCheckInputStartMinutes}
          onBlur={handleOnBlurMinutes}
          className="slider-timer-minutes"
          ref={startMinutesRef}
        />
        <img src={starImg} className="slider-timer-left-star" alt="" />
      </div>
      <div className="slider-timer-right">
        <span>-</span>
        <input
          disabled={true}
          type="number"
          onChange={handleCheckEndInputHours}
          onBlur={handleEndTimeOnBlurHours}
          className="slider-timer-hours-end"
          ref={endHoursRef}
        />
        <span>:</span>
        <input
          disabled={true}
          type="number"
          onChange={handleCheckEndInputMinutes}
          onBlur={handleEndTimeOnBlurMinutes}
          className="slider-timer-minutes-end"
          ref={endMinutesRef}
        />
      </div>
    </div>
  );
};

export default CustomTimer;
